import { TAXONOMY, RADIO_COLORS } from '../../common/constants';
import { TAXONOMY_BRAND_VIEW } from '../../screens/auth/constants';

export const data = [
    {
        key: 1,
        label: 'Category',
        id: 1,
        color: RADIO_COLORS[2],
        value: TAXONOMY.CATEGORY,
    },
    {
        key: 2,
        label: 'Object',
        id: 2,
        color: RADIO_COLORS[5],
        value: TAXONOMY.OBJECT,
    },
    {
        key: 3,
        label: 'Material',
        id: 3,
        color: RADIO_COLORS[4],
        value: TAXONOMY.MATERIAL,
    },
    {
        key: 4,
        label: 'Brand',
        id: 4,
        color: RADIO_COLORS[3],
        value: TAXONOMY.BRAND,
        isProtected: true,
        permission: TAXONOMY_BRAND_VIEW,
    },
];
